import { API_DICTIONARY } from 'constants/api'
import { TCreateRebatesPaymentData, TRebatePaymentData } from './types'
import { HTTP_METHODS } from 'constants/api'
import Fetcher from 'services/Fetcher'
import { TBankAccountsListResponse } from 'features/BankAccount/types'

const fetcher = new Fetcher({})

export const fetchRebatePaymentData = async (rebate_quarter_id: string) =>
  fetcher.request<unknown, TRebatePaymentData>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.REBATES_DASHBOARD}${rebate_quarter_id}/${API_DICTIONARY.PAYMENT}`,
    method: HTTP_METHODS.GET
  })

export const fetchPaymentOptions = async (businessAccountId: string) =>
  fetcher.request<unknown, TBankAccountsListResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${businessAccountId}/${API_DICTIONARY.BANK_ACCOUNTS}?purposes=payable&statuses=verified&payment_method_type=ach-debit-collect`,
    method: HTTP_METHODS.GET
  })

export const createRebatesPayment = async (
  businessAccountId: string,
  data: TCreateRebatesPaymentData
) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.REBATES_DASHBOARD}${businessAccountId}/${API_DICTIONARY.PAYMENT}`,
    method: HTTP_METHODS.POST,
    data
  })
